export const css = {
	root: '_1XChCLtD',
	flipContainer: '_1Db6t_m4',
	flipped: '_1jw56-BB',
	flipper: '_36fzMjod',
	front: '_1YQrVdTc',
	back: 'apfvHf5l',
	cardDefinition: '_2CIWxy2x',
	cardTerm: '_1k9tvC1J',
	oneaction: '_rWoApne',
	' _key': 'quiz-widgets/definition'
};

export default css;
